import * as React from "react";
import * as ReactDOM from "react-dom";
import {IEventForList} from '../../../interfaces/models/IEvent';
import Ajax from '../../lib/Ajax';
import InvitateResponseBox from "./InvitateResponseBox";
import { Tools } from "../../lib/Tools";
interface IEventListProps {
    invitationMode:boolean
}

interface IEventListState {
    items:Array<IEventForList>
    loadingText:string
}

class EventListComp extends React.Component<IEventListProps, IEventListState>{

    constructor(props:IEventListProps){
        super(props);
        this.init();
    }

    private init(){
        this.state = {
            items: [],
            loadingText: 'Loading...'
        };
        // tslint:disable-next-line:no-unused-expression
        new Ajax('/event/getList', 'POST', { invitationMode: this.props.invitationMode }, (data:Array<IEventForList>) => {
            this.setState({
                items : data,
                loadingText: 'Nincs találat!'
            });
        });

    }

    private eventLikeClickHandler(evt, id:number, status:string): void {
        evt.preventDefault();
        // tslint:disable-next-line:no-unused-expression
        new Ajax('/event/likeToggle', 'POST', {
            id: id,
            status: status
        }, (ret)=>{
            if ( ret.success !== undefined ) {
                var items = this.state.items;
                for (var key in items) {
                    var item = items[key];
                    if ( item.id === id ) {
                         // tslint:disable-next-line:no-unused-expression
                         new Ajax('/event/get', 'POST', {
                                id: id,
                            }, (retItem)=>{
                                items[key] = retItem;
                                this.setState({
                                    items: items
                                } as IEventListState);
                        });
                        break;
                    }
                }
            }
        });
    }


    render() {
        if ( this.state.items.length === 0 ) {
            return <div>
                { this.state.loadingText }
            </div>
        }
        return (
            <div>
                {
                    this.state.items.map((item:IEventForList, index:number) => {
                        var url:string = window.location.pathname + '/' + item.id;
                        return <div key={index}>

                            { item.invited === true?<InvitateResponseBox eventId={ item.id } status={ item.invitedStatus } />:'' }

                            <div>
                                <div className="is-container">
                                    { item.leadImage !== ''? <div className="row col3 image_text_box">
                                        <div className="box">
                                            <img src={ item.leadImage } />
                                        </div>
                                        <div className="box two p5 desc_box">
                                            <a href={ url }>
                                                <h3>
                                                    { item.name }
                                                </h3>
                                            </a>


                                            <div className="desc">
                                                <div className="address_row">
                                                    <span>
                                                        Helyszín:
                                                    </span> { item.address }
                                                </div>
                                                <div className="time_row">
                                                    <span>
                                                        Időpont:
                                                    </span> { Tools.dateTimeDistanceFormatter(item) }
                                                </div>

                                                <div className="owner_row">
                                                    <span>
                                                        Szervező:
                                                    </span> <a href={ '/profilok/'+item.userId } className="owner" target="_blank">
                                                        { item.ownerName }
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>: <div className="row">
                                        <div className="desc_box">
                                            <a href={ url }>
                                                <h3>
                                                    { item.name }
                                                </h3>
                                            </a>


                                            <div className="desc">
                                                <div className="address_row">
                                                    <span>
                                                        Helyszín:
                                                    </span> { item.address }
                                                </div>
                                                <div className="time_row">
                                                    <span>
                                                        Időpont:
                                                    </span> { Tools.dateTimeDistanceFormatter(item) }
                                                </div>

                                                <div className="owner_row">
                                                    <span>
                                                        Szervező:
                                                    </span> <a href={ '/profilok/'+item.userId } className="owner" target="_blank">
                                                        { item.ownerName }
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div> }
                                    <div className="row">
                                        <div>
                                            <p>
                                                { item.lead }
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="statusbar">
                                <ul>
                                   <li className={ item.loved ? 'active' :'' }>
                                        <a onClick={ e => this.eventLikeClickHandler(e, item.id ,'love') }
                                        >
                                            <span className="ion-heart"> { item.love }</span>
                                        </a>
                                    </li>
                                    <li className={ item.liked ? 'active' :'' }>
                                        <a onClick={ e => this.eventLikeClickHandler(e, item.id ,'like') }>
                                            <span className="ion-happy"> { item.like }</span>
                                        </a>
                                    </li>
                                    <li className={ item.disliked ? 'active' :'' }>
                                        <a onClick={ e => this.eventLikeClickHandler(e, item.id ,'dislike') }>
                                            <span className="ion-sad"> { item.dislike }</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    })
                }
            </div>
        );
    }
}
export default class InitEventListComp {
    constructor() {
        var div: HTMLDivElement = document.getElementById('even_list_component') as HTMLDivElement;
        if (div !== null) {
            var invitationMode:boolean = div.dataset.invitation_mode==="true"?true:false;
            ReactDOM.render(< EventListComp invitationMode={ invitationMode }/>, div);
        }
    }
}



// WEBPACK FOOTER //
// ./components/event/EventList.tsx